import about from './about.json'
import home from './home.json'
import producers from './producers.json'
import affiliates from './affiliates.json'
import solutions from './solutions.json'
import hotmartApp from './hotmartApp.json'
import organization from './organization.json'
import tour from './tour.json'
import legal from './legal.json'
import payments from './payments.json'
import pricing from './pricing.json'

export default {
  about,
  home,
  producers,
  affiliates,
  solutions,
  hotmartApp,
  organization,
  tour,
  legal,
  payments,
  pricing,
}
